module.exports = __webpack_public_path__ + "static/media/map-layer-hover--new~blhXnwAb.ca4d7a46.svg";